import SignUp from "./Auth/components/SignUp";
import Login from "./Auth/components/Login";

import { auth } from "../base";
import firebase from "firebase";

import { Redirect } from "react-router-dom";

export default function Splash() {
	const path = window.location.pathname;

	// if user is logged in, redirect to home
	if (auth.currentUser) {
		return <Redirect to="/" />;
	}

	var provider = new firebase.auth.GoogleAuthProvider();
	const googleSignIn = () => {
		auth
			.signInWithPopup(provider)
			.then(() => {
				window.location.href = "/";
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const emailSignUp = (email, password, firstName = "", lastName = "") => {
		auth
			.createUserWithEmailAndPassword(email, password)
			.then((userCredential) => {
				window.location.href = "/";
			})
			.catch((error) => console.log(error));
	};

	const emailLogin = (email, password, firstName = "", lastName = "") => {
		auth
			.signInWithEmailAndPassword(email, password)
			.then((userCredential) => {
				window.location.href = "/";
			})
			.catch((error) => console.log(error));
	};

	return (
		<div className="splash-page">
			{path == "/login" ? (
				<Login googleSignIn={googleSignIn} emailLogin={emailLogin} />
			) : (
				<SignUp googleSignIn={googleSignIn} emailSignUp={emailSignUp} />
			)}
		</div>
	);
}
